import {Record} from "immutable";
import { AuthState } from '../reducers/applyAuth';

const getToken = (state: Record<AuthState>, token: string): string => state.getIn(['auth', 'auth', 'token']);

export const makeTokenSelector = (): (state: Record<AuthState>) => string => (state: Record<AuthState>) => getToken(state, 'token');
